import type { CityConfig } from "../city-template/types";

export const lewisvilleConfig: CityConfig = {
  city: "Lewisville",
  state: "Texas",
  stateAbbr: "TX",
  slug: "lewisville",
  route: "/lewisville",
  title: "Emergency Passport Lewisville, TX — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Lewisville, TX — as fast as 24 hours. Serving Denton County and the DFW metroplex with Lewisville Lake and Vista Ridge area coverage. A+ BBB rated registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Lewisville, TX",
  heroSubtitle: "DFW business trip to London with two weeks notice? Family vacation to Cancun and your passport expired? Lewisville Lake cruise departing soon? We help Denton County residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Lewisville%20Texas%20suburban%20cityscape%20with%20Lewisville%20Lake%20shoreline%20modern%20residential%20neighborhoods%20and%20downtown%20skyline%20at%20golden%20hour%20warm%20Texas%20sunset%20colors%20Denton%20County%20DFW%20metroplex%20landscape%20professional%20drone%20photography%20vibrant%20warm%20tones&width=1800&height=700&seq=lewisville-hero-tx-2026&orientation=landscape",
  heroImageAlt: "Lewisville Texas Denton County suburban cityscape with Lewisville Lake at golden hour",
  geoPosition: "33.0462;-96.9942",
  geoPlacename: "Lewisville, Texas",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Dallas Passport Agency",
    address: "1100 Commerce Street, Suite 200, Dallas, TX 75242",
    distance: "Located in downtown Dallas — approximately 25 miles southeast of Lewisville via I-35E",
  },
  nearbyCitiesZips: [
    { name: "Lewisville", zips: "75029, 75057, 75067, 75077" },
    { name: "Flower Mound", zips: "75022, 75027, 75028" },
    { name: "Highland Village", zips: "75077" },
    { name: "The Colony", zips: "75056" },
    { name: "Coppell", zips: "75019, 75099" },
    { name: "Carrollton", zips: "75006, 75007, 75010, 75011" },
    { name: "Denton", zips: "76201–76210" },
    { name: "Frisco", zips: "75033–75036" },
    { name: "Plano", zips: "75023–75094" },
    { name: "Grapevine", zips: "76051, 76092, 76099" },
    { name: "Southlake", zips: "76092" },
    { name: "Keller", zips: "76244, 76248, 76262" },
    { name: "Corinth", zips: "76208, 76210" },
    { name: "Little Elm", zips: "75068" },
    { name: "Addison", zips: "75001" },
    { name: "Farmers Branch", zips: "75234, 75244" },
    { name: "Dallas", zips: "75201–75299" },
    { name: "Fort Worth", zips: "76101–76199" },
    { name: "Irving", zips: "75014–75063" },
    { name: "Arlington", zips: "76001–76018" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent DFW departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Denton County Coverage", desc: "Serving Lewisville, Flower Mound, Highland Village, and The Colony" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Dallas, TX", route: "/dallas" },
    { name: "Fast passport renewal in Fort Worth, TX", route: "/fort-worth" },
    { name: "Emergency passport help in Denton, TX", route: "/denton" },
    { name: "Urgent passport services in Frisco, TX", route: "/frisco" },
    { name: "Passport courier services in Plano, TX", route: "/plano" },
    { name: "Fast passport renewal in Carrollton, TX", route: "/carrollton-tx" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Lewisville remotely via secure courier. We do not have a walk-in office in Lewisville — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Denton County and the DFW metroplex.",
  fpcOfficeAddress: "1005 Congress Ave, Austin, Texas 78701",
  fpcOfficeDistance: "Serving all of Denton County including Lewisville, Flower Mound, Highland Village, The Colony, Corinth, and Lake Dallas",
  serviceAreaIntro: "From the shores of Lewisville Lake to the master-planned communities of Flower Mound and Highland Village, from the booming tech corridor of The Colony to the historic downtown of Denton, from the corporate campuses of Coppell to the family neighborhoods of Carrollton — Fast Passport Center serves the entire Lewisville and Denton County region. We regularly help DFW metroplex travelers get their passports fast without navigating downtown Dallas.",
  nearbyCitiesIntro: "We serve all Lewisville neighborhoods and the surrounding DFW area including Flower Mound, Highland Village, The Colony, Coppell, Carrollton, Denton, Frisco, Plano, Grapevine, Southlake, Keller, Corinth, Little Elm, Addison, Farmers Branch, Dallas, Fort Worth, Irving, and Arlington. If you are anywhere in Denton County or the northern DFW metroplex, we have you covered.",
  howItWorksIntro: "Most Lewisville travelers complete everything online and ship documents overnight. No need to drive to downtown Dallas or wait in line at the regional agency.",
  mistakesIntro: "Lewisville travelers often face the hassle of driving to downtown Dallas for the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Lewisville and Denton County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Lewisville? Here are the most common ones we hear from DFW travelers.",
  statePageRoute: "/states/texas",
  statePageName: "Texas",
  dmvWebsite: "https://www.dps.texas.gov",
  dmvLabel: "Texas DPS — Driver License Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Lewisville travelers with immediate departure needs — as fast as 24 hours for urgent DFW international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer M.",
      location: "Lewisville, TX",
      rating: 5,
      text: "My passport expired 3 days before our family cruise from Galveston. Fast Passport Center had my renewal in 26 hours. I never left Lewisville. Their DFW metro service is unbeatable.",
      service: "Passport Renewal",
    },
    {
      name: "David R.",
      location: "Flower Mound, TX",
      rating: 5,
      text: "Emergency passport for an unexpected business trip to Singapore. Got it in 28 hours. Fast Passport Center handled everything — way better than driving to downtown Dallas. Incredible service for Denton County professionals.",
      service: "Emergency Passport",
    },
    {
      name: "Lisa T.",
      location: "Highland Village, TX",
      rating: 5,
      text: "First passport for my 16-year-old before our Europe trip. Fast Passport Center guided us through every form and had her passport in 4 days. So easy for Lewisville families.",
      service: "Child Passport",
    },
    {
      name: "Michael P.",
      location: "The Colony, TX",
      rating: 5,
      text: "Lost my passport 2 days before flying to London. Fast Passport Center had a replacement in 25 hours. Absolutely saved my business trip. Best service in the DFW area.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "lewisville-1",
      name: "Lewisville Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "101 E Main St",
      city: "Lewisville",
      state: "TX",
      zip: "75057",
      phone: "(972) 436-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Lewisville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Lewisville facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "lewisville-2",
      name: "Flower Mound Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2501 Cross Timbers Rd",
      city: "Flower Mound",
      state: "TX",
      zip: "75028",
      phone: "(972) 355-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles west of Lewisville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Flower Mound and west Lewisville. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "lewisville-3",
      name: "Denton County Clerk — Lewisville",
      type: "County Clerk Passport Acceptance",
      address: "701 S Stemmons Fwy",
      city: "Lewisville",
      state: "TX",
      zip: "75067",
      phone: "(972) 434-7100",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "South Lewisville",
      website: "https://www.dentoncounty.gov/",
      websiteLabel: "Denton County Clerk",
      notes: "Accepts passport applications. Extended hours compared to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "lewisville-4",
      name: "Carrollton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2030 E Jackson Rd",
      city: "Carrollton",
      state: "TX",
      zip: "75006",
      phone: "(972) 242-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles southeast of Lewisville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Nearby facility serving southern Denton County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "lewisville-5",
      name: "The Colony Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4900 Blair Oaks Dr",
      city: "The Colony",
      state: "TX",
      zip: "75056",
      phone: "(972) 625-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles east of Lewisville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves The Colony and east Lewisville. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "lewisville-6",
      name: "Denton Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "101 E McKinney St",
      city: "Denton",
      state: "TX",
      zip: "76201",
      phone: "(940) 387-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles north of Lewisville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "County seat facility serving Denton County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Fastest Processing", agency: "24–48 hours", fpc: "Same day (emergencies only)" },
    { feature: "Appointment Required", agency: "No", fpc: "Yes — call NPIC, limited slots" },
    { feature: "Processing Speed", agency: "Guaranteed turnaround", fpc: "Same-day if approved (rare)" },
    { feature: "Document Review", agency: "Yes — we check before submission", fpc: "No — rejected if wrong" },
    { feature: "Travel to Agency", agency: "No — ship from home", fpc: "Yes — 35 min drive to Dallas" },
    { feature: "Agent Support", agency: "Yes — dedicated agent assigned", fpc: "No — government clerk only" },
    { feature: "Status Updates", agency: "Yes — daily email updates", fpc: "No — no tracking provided" },
    { feature: "Guaranteed Timing", agency: "Yes — contractual turnaround", fpc: "No — subject to availability" },
    { feature: "Denton County Knowledge", agency: "Yes — local expertise", fpc: "Generic" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Lewisville photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Denton County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Lewisville applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Dallas regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Denton County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Lewisville travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Lewisville." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Lewisville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Lewisville before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Lewisville for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the drive to downtown Dallas." },
    { q: "How fast can I renew my passport in Lewisville?", a: "Fast Passport Center offers fast passport renewal in Lewisville in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Lewisville?", a: "The nearest regional passport agency to Lewisville is the Dallas Passport Agency, approximately 25 miles southeast in downtown Dallas via I-35E. For urgent processing without the drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Lewisville without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Lewisville?", a: "Same-day passport appointments are only available at the Dallas Regional Passport Agency — approximately 35 minutes from Lewisville — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Denton County residents." },
    { q: "Do you serve the entire Lewisville and Flower Mound area?", a: "Absolutely. Fast Passport Center serves the entire Lewisville area including Flower Mound, Highland Village, The Colony, Coppell, Carrollton, Denton, Frisco, Plano, Grapevine, Southlake, Keller, Corinth, and Little Elm. Our courier service works seamlessly from any address in Denton County and the northern DFW metroplex." },
    { q: "Can I expedite a child passport in Lewisville?", a: "Yes. Fast Passport Center expedites child passports in Lewisville for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Denton County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Lewisville with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Dallas Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Lewisville", address: "101 E Main St, Lewisville, TX 75057", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Flower Mound", address: "2501 Cross Timbers Rd, Flower Mound, TX 75028", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Lewisville", address: "701 S Stemmons Fwy, Lewisville, TX 75067", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — The Colony", address: "4900 Blair Oaks Dr, The Colony, TX 75056", hours: "Mon–Sun: 8AM–10PM" },
    { name: "FedEx Office — Lewisville", address: "2401 S Stemmons Fwy, Lewisville, TX 75067", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "Walgreens — Carrollton", address: "2030 E Jackson Rd, Carrollton, TX 75006", hours: "Mon–Sun: 7AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Texas DPS — Lewisville",
      address: "400 N Valley Pkwy, Lewisville, TX 75067",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Texas DPS — Carrollton",
      address: "4600 TX-121, Carrollton, TX 75010",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Carrollton and south Denton County. REAL ID available.",
      featured: false,
    },
    {
      name: "Texas DPS — Denton",
      address: "820 S I-35E, Denton, TX 76205",
      hours: "Mon–Fri: 8AM–5PM",
      note: "County seat mega center. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "DFW",
      name: "Dallas/Fort Worth International Airport",
      distance: "15 miles south of Lewisville",
      address: "2400 Aviation Dr, DFW Airport, TX 75261",
      note: "Major international hub serving the DFW metroplex. American Airlines hub with direct flights to Europe, Asia, and Latin America. About 20 minutes from Lewisville via TX-121.",
      flightUrl: "https://www.dfwairport.com/",
      flightLabel: "DFW Airport",
      featured: true,
    },
    {
      code: "DAL",
      name: "Dallas Love Field Airport",
      distance: "25 miles southeast of Lewisville",
      address: "8008 Herb Kelleher Way, Dallas, TX 75235",
      note: "Southwest Airlines hub with domestic and limited international flights. About 30 minutes from Lewisville via I-35E.",
      flightUrl: "https://www.dallas-lovefield.com/",
      flightLabel: "DAL Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the Texas Department of State Health Services Vital Statistics. Online, mail, or in-person options available for Denton County.",
      url: "https://dshs.texas.gov/vs/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Texas DSHS Vital Statistics. Required for estate and legal matters in the Lewisville and Denton County area.",
      url: "https://dshs.texas.gov/vs/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Denton County Clerk. Certified copies available for name changes and legal purposes in Lewisville.",
      url: "https://www.dentoncounty.gov/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Denton County District Clerk. Required for name change passport corrections and legal documentation.",
      url: "https://www.dentoncounty.gov/",
    },
  ],
};